// scroll
export function scroll() {
    const header = document.querySelector('header');

    if (typeof header != 'undefined' && header != null) {
        let scrollEvent = () => {
            let top = window.pageYOffset || document.documentElement.scrollTop;
            if (top > 80) {
                header.classList.add('scrolled-hidden');
            } else {
                header.classList.remove('scrolled-hidden');
            }
        };

        window.addEventListener('scroll', scrollEvent, false);
    }
}
